import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import NowPlayingViewSwitcher from "./NowPlayingViewSwitcher";

type Props = {
  track: any;
  onClose: () => void;
};

const DesktopNowPlayingModal: React.FC<Props> = ({ track, onClose }) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const modal = modalRef.current;
      const player = document.getElementById("global-player");

      if (
        modal &&
        !modal.contains(event.target as Node) &&
        (!player || !player.contains(event.target as Node))
      ) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
      <Box
        sx={{
          position: "fixed",
          bottom: "80px", // same as before
          left: "20px",
          width: "calc(50vw - 200px)",
          maxHeight: "calc(90vh - 90px)",
          backgroundColor: "#181220",
          borderRadius: "10px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
          zIndex: 1000,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
>
      <NowPlayingViewSwitcher track={track} onClose={onClose} />
    </Box>
  );
};

export default DesktopNowPlayingModal;





